module.exports = __webpack_public_path__ + "img/icon_wechat.448d2c2d.png";